import { render, staticRenderFns } from "./unitForm.vue?vue&type=template&id=19b4f67a&scoped=true&"
import script from "./unitForm.vue?vue&type=script&lang=js&"
export * from "./unitForm.vue?vue&type=script&lang=js&"
import style0 from "./unitForm.vue?vue&type=style&index=0&id=19b4f67a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19b4f67a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dgq/mei_bao_pro/insuranceagent-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19b4f67a')) {
      api.createRecord('19b4f67a', component.options)
    } else {
      api.reload('19b4f67a', component.options)
    }
    module.hot.accept("./unitForm.vue?vue&type=template&id=19b4f67a&scoped=true&", function () {
      api.rerender('19b4f67a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/insurance/policy/entry/unitForm.vue"
export default component.exports